<template>
  <div v-if="storeDetail" class="store-detail-page c:col-center-stretch">
    <StoreDetailHeader :data="storeDetail" />
    <HDivider />
    <div class="store-detail-tabview">
      <TabView :tabs="tabs">
        <template #infos>
          <div class="store-infos">
            <!-- <StoreInfoCell label="加入时间">{{
            "2020-03-30 20:19:32" | formatDateTime
          }}</StoreInfoCell> -->
            <StoreInfoCell label="最后销售时间">{{
              formattedTime
            }}</StoreInfoCell>
            <StoreInfoCell label="总销售额"
              >￥ {{ storeDetail.salesAmount | filterPrice }}</StoreInfoCell
            >
          </div>
        </template>
        <template #salers>
          <div class="store-sale-list">
            <Empty v-if="saleList.length === 0 && !loading" text="暂无员工" />
            <van-list
              v-model="loading"
              :finished="finished"
              :finished-text="finishedText"
              @load="getSaleList"
            >
              <saler-list-cell
                v-for="(item, index) in saleList"
                :key="index"
                :data="item"
            /></van-list>
            <CBottomPad />
          </div>
        </template>
      </TabView>
    </div>
  </div>
</template>

<script>
import { getEmployeeList, getRMStoreDetail } from "@/api";
import CBottomPad from "@/components/common/CBottomPad.vue";
import Empty from "@/components/common/Empty.vue";
import HDivider from "@/components/common/HDivider.vue";
import TabView from "@/components/common/TabView.vue";
import SalerListCell from "@/components/saler-list/SalerListCell.vue";
import StoreDetailHeader from "@/components/store-management/StoreDetailHeader.vue";
import StoreInfoCell from "@/components/store-management/StoreInfoCell.vue";
import normalPage from "@/mixins/normal-page";
import { mapState } from "vuex";

export default {
  mixins: [normalPage],
  components: {
    HDivider,
    StoreDetailHeader,
    TabView,
    Empty,
    StoreInfoCell,
    SalerListCell,
    CBottomPad,
  },
  data() {
    return {
      tabs: [
        {
          key: "infos",
          label: "店铺数据",
        },
        {
          key: "salers",
          label: "销售列表",
        },
      ],
      storeDetail: null,
      loading: false,
      saleList: [],
      finished: false,
      finishedText: "",
    };
  },
  computed: {
    ...mapState(["user"]),
    storeId() {
      return this.$route.query.storeId;
    },
    formattedTime() {
      return this.storeDetail?.lastSalesTime
        ? this.$moment(this.storeDetail.lastSalesTime).format(
            "YYYY-MM-DD HH:mm:ss"
          )
        : "";
    },
  },
  mounted() {
    this.getStoresDetail();
    // this.getSaleList();
  },
  methods: {
    async getStoresDetail() {
      try {
        const base = this.user.stores.find(
          (store) => store.storeId === this.storeId
        );
        const res = await getRMStoreDetail(this.storeId);
        // const res = {};
        this.storeDetail = { ...base, ...res };
        console.log("getStoresDetail", this.storeDetail);
      } catch (error) {
        if (error?.message) this.$toast(error.message);
      }
    },
    async getSaleList() {
      try {
        this.loading = true;
        this.saleList = [];
        const res = await getEmployeeList({
          storeId: this.storeId,
        });
        this.saleList = res;
        console.log("getSaleList", this.saleList);
        this.finishedText = "";
      } catch (error) {
        if (error?.message) this.$toast(error.message);
        this.finishedText = "";
      } finally {
        this.loading = false;
        this.finished = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.store-detail-page {
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  border-top: solid 1px #f2f2f2;

  .store-detail-tabview {
    flex: 1;
    width: 100%;
    // height: 0;
  }

  .store-infos {
    box-sizing: border-box;
    width: 100%;
    margin-top: 4/20rem;
    padding: 0 20/20rem;
    border-top: solid 1px #f2f2f2;
    background-color: #fff;
  }

  .store-sale-list {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding-top: 4/20rem;
    border-top: solid 1px #f2f2f2;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
